module.exports = __webpack_public_path__ + "img/中介超市.104b08aa.png";